import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const AboutUsShowcase = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    const particleArray = Array.from({ length: 50 }).map(() => ({
      id: Math.random(),
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      size: Math.random() * 4 + 2,
      opacity: Math.random() * 0.5 + 0.3,
      speedX: Math.random() * 0.5 - 0.25,
      speedY: Math.random() * 0.5 - 0.25,
    }));
    setParticles(particleArray);

    const updateParticles = () => {
      setParticles((prev) =>
        prev.map((particle) => ({
          ...particle,
          x:
            (particle.x + particle.speedX + window.innerWidth) %
            window.innerWidth,
          y:
            (particle.y + particle.speedY + window.innerHeight) %
            window.innerHeight,
        }))
      );
      requestAnimationFrame(updateParticles);
    };

    updateParticles();
    return () => cancelAnimationFrame(updateParticles);
  }, []);

  return (
    <div className="bg-black text-white py-16 relative overflow-hidden px-4 sm:px-10 md:px-24 lg:px-28">
      {/* Particle Effect */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {particles.map((particle) => (
          <motion.div
            key={particle.id}
            className="absolute rounded-full bg-green-500"
            style={{
              width: particle.size,
              height: particle.size,
              left: particle.x,
              top: particle.y,
              opacity: particle.opacity,
            }}
          />
        ))}
      </div>

      {/* Grid Content */}
      <div className="relative container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 lg:gap-6 items-center z-10">
        {/* Text Content */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="space-y-6"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-green-500">
            ABOUT US
          </h1>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed">
            <span className="font-semibold text-white">Introducing Beyond Bloom</span>. At Beyond Bloom, our team brings together the best of cannabis cultivation know-how and modern innovation. Our team includes expert growers, seasoned entrepreneurs, and industry veterans. Together, we are committed to delivering unparalleled products to our partners.
          </p>
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className="mt-6 inline-block px-6 py-3 bg-green-400 text-black rounded-lg font-semibold text-lg hover:bg-green-500 transition duration-300"
          >
            Contact Us
          </motion.button>
        </motion.div>

        {/* Image Section */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="relative flex justify-center"
        >
          <motion.img
            src="/images/aboutus.jpg"
            alt="Main Strain"
            className="w-full max-w-xs h-auto object-cover rounded-xl border-4 border-green-500 shadow-lg hover:scale-105 transform transition duration-500"
            whileHover={{ scale: 1.05, rotate: 3 }}
          />

          <motion.img
            src="/hero2.jpg"
            alt="Strain 3"
            className="absolute bottom-[-30px] right-[-20px] w-64 h-64 object-cover rounded-lg border-2 border-green-300 shadow-md hidden md:block"
            whileHover={{ scale: 1.15 }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUsShowcase;
